import { AnalyticsStore, ContextStore } from 'bernie-plugin-mobx';
import { inject } from 'mobx-react';
import * as React from 'react';

import { PropertyFilteredReviews } from '@shared-ui/lodging-reviews';
import { useLocalization } from '@shared-ui/localization-context';

import { adaptSearchCriteria } from 'src/common/stores/adapters/bex-api/common/search-criteria-adapter';
import { CurrentHotelStore } from 'stores/current-hotel-store';

import { UitkSheetContent } from 'uitk-react-sheet';
import { UitkToolbar } from 'uitk-react-toolbar';

interface SharedUiPropertyReviewsDialogProps {
  currentHotel?: CurrentHotelStore;
  analytics?: AnalyticsStore;
  context?: ContextStore;
  onDialogClose: () => void;
}

export const SharedUiPropertyReviewsDialog: React.FC<SharedUiPropertyReviewsDialogProps> = inject(
  'analytics',
  'currentHotel',
  'context'
)(({ analytics, currentHotel, context, onDialogClose }) => {
  /* istanbul ignore next */
  const propertyId = currentHotel?.hotelId?.toString();
  const searchCriteria = context && currentHotel && adaptSearchCriteria(context, currentHotel.searchCriteria);

  const { formatText } = useLocalization();

  if (!propertyId || !searchCriteria) {
    return null;
  }

  /* istanbul ignore next */
  const isDated = Boolean(currentHotel?.searchCriteria?.startDate?.length);

  return (
    <>
      <UitkToolbar
        toolbarTitle={formatText('hotels.infosite.reviews.title')}
        navigationContent={{
          onClick: onDialogClose,
          navIconLabel: formatText('hotels.infosite.reviews.cancelButton.a11yLabel'),
          onClickAnalytics: analytics?.setupTracker('ReviewsDialog', 'close reviews'),
        }}
      />
      <UitkSheetContent fullSheetContentMaxWidth="extra-large">
        <PropertyFilteredReviews inputs={{ propertyId, searchCriteria, includeRecentReviews: isDated }} />
      </UitkSheetContent>
    </>
  );
});

SharedUiPropertyReviewsDialog.displayName = 'SharedUiPropertyReviewsDialog';
